import Config from "config.json";

export const apiBaseUrl = Config.REACT_APP_API_BASE_URL
export const webSocketBaseUrl = Config.REACT_APP_WEBSOCKET_BASE_URL
